import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import MenuIcon from "@material-ui/icons/Menu";
import ImageIcon from "@material-ui/icons/Image";
import MailIcon from "@material-ui/icons/Mail";
import { Roles } from "../../../util/PermissionProvider";
import CheckCircleOutlineOutlinedIcon from "@material-ui/icons/CheckCircleOutlineOutlined";
import MonetizationOnOutlinedIcon from "@material-ui/icons/MonetizationOnOutlined";
import EventNoteIcon from "@material-ui/icons/EventNote";
import PersonIcon from "@material-ui/icons/Person";
import AddBoxIcon from "@material-ui/icons/AddBox";
import PeopleIcon from "@material-ui/icons/People";
import LocalActivityIcon from "@material-ui/icons/LocalActivity";
import MovieIcon from "@material-ui/icons/Movie";
import EventOutlinedIcon from "@material-ui/icons/EventOutlined";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import Event from "@material-ui/icons/Event";
import { Star } from "@material-ui/icons";
import HistoryIcon from "@material-ui/icons/History";
import FolderIcon from "@material-ui/icons/Folder";
import PhoneIcon from "@material-ui/icons/Phone";
import ThumbUpAltIcon from "@material-ui/icons/ThumbUpAlt";
import SelectAllIcon from "@material-ui/icons/SelectAll";
import AssignmentIcon from "@material-ui/icons/Assignment";
import WorkIcon from "@material-ui/icons/Work";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import SubscriptionsIcon from "@material-ui/icons/Subscriptions";
import FavoriteIcon from '@material-ui/icons/Favorite';

// const menu = [
//   {
//     name: "Menu",
//     path: "/hkiff/menu",
//     icon: <MenuIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
//   },
//   {
//     name: "Programmes & Periods",
//     path: "/hkiff/programmes",
//     key: "programme",
//     icon: <VideoLibraryIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
//     children: [
//       {
//         name: "Programmes",
//         path: "/hkiff/programmes",
//       },
//       {
//         name: "Periods",
//         path: "/hkiff/period",
//       },
//     ],
//   },
//   { divider: true },
// ];

const menu = [
  {
    name: "HKIFF",
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
  },
  {
    name: "Menu",
    path: "/hkiff/menu",
    icon: <MenuIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
  },
  {
    name: "News",
    path: "/hkiff/news",
    icon: <InsertDriveFileIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
  },
  {
    name: "eDM",
    path: "/hkiff/edm",
    icon: <MailIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
  },
  {
    name: "Region Management",
    path: "/hkiff/region-management/venue",
    icon: <LocationOnIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
  },
  {
    name: "Banner",
    path: "/hkiff/banner",
    icon: <ImageIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
  },
  {
    name: "Subscription",
    path: "/hkiff/subscription",
    icon: <AddBoxIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
  },
  {
    name: "Ticket & FAQ",
    path: "/hkiff/ticket-and-faq/ticketing",
    icon: <LocalActivityIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
    children: [
      {
        name: "Ticketing Info",
        path: "/hkiff/ticket-and-faq/ticketing",
      },
      {
        name: "Festival Pass",
        path: "/hkiff/ticket-and-faq/festival-pass",
      },
      {
        name: "FAQ",
        path: "/hkiff/ticket-and-faq/faq",
      },
      {
        name: "Festival Pass Notice",
        path: "/hkiff/ticket-and-faq/festival-pass-notice",
      },
    ],
  },
  // {
  //   name: "Membership",
  //   path: "/hkiff/membership/member",
  //   icon: <PeopleIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
  //   requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
  //   children: [
  //     {
  //       name: "Member",
  //       path: "/hkiff/membership/member",
  //     },
  //     {
  //       name: "Plan",
  //       path: "/hkiff/membership/plan",
  //     },
  //     {
  //       name: "Gift",
  //       path: "/hkiff/membership/gift",
  //     },
  //     {
  //       name: "Configuration",
  //       path: "/hkiff/membership/configuration",
  //     },
  //     {
  //       name: "Email",
  //       path: "/hkiff/membership/email",
  //     },
  //   ],
  // },
  // { divider: true },
  {
    name: "HKIFF Festival",
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
  },
  {
    name: "Event",
    path: "/hkiff/event",
    icon: <EventOutlinedIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
  },
  {
    name: "HKIFF List",
    path: "/hkiff/hkiff",
    icon: <SubscriptionsIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
  },
  {
    name: "Films",
    path: "/hkiff/film",
    icon: <MovieIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
    children: [
      {
        name: "Film List",
        path: "/hkiff/film",
      },
      {
        name: "Film Category",
        path: "/hkiff/film-category",
      },
      {
        name: "Film Tag",
        path: "/hkiff/film-tag",
      },
      {
        name: "Film Icon",
        path: "/hkiff/film-icon",
      },
    ],
  },
  {
    name: "Festival Daily",
    path: "/hkiff/festival-daily",
    icon: <EventNoteIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
  },
  {
    name: "Sponsor",
    path: "/hkiff/sponsors",
    icon: <PersonIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
    children: [
      {
        name: "Sponsors Listing",
        path: "/hkiff/sponsors",
      },
      {
        name: "Sponsors Category",
        path: "/hkiff/sponsors-category",
      },
    ],
  },
  {
    name: "Programme",
    path: "/hkiff/programme/programme",
    icon: <SubscriptionsIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
    children: [
      {
        name: "Programme Listing",
        path: "/hkiff/programme/programme",
      },
      {
        name: "Programme Category",
        path: "/hkiff/programme/programme-category",
      },
    ],
  },
  {
    name: "Audience Choice Award",
    path: "/hkiff/aca/score-board",
    key: "aca",
    icon: <FavoriteIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
    children: [
      {
        name: "General",
        path: "/hkiff/aca/score-board",
      },
      {
        name: "Film List",
        path: "/hkiff/aca/film-list",
      },
      {
        name: "Banner",
        path: "/hkiff/aca/banner",
      },
      {
        name: "Setting",
        path: "/hkiff/aca/setting",
      },
    ],
  },
  {
    name: "Entry Management",
    path: "/hkiff/call-for-entry",
    key: "event-manage",
    icon: <ExitToAppIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
    children: [
      {
        name: "Call for Entry",
        path: "/hkiff/call-for-entry",
      },
      {
        name: "Invited Entry",
        path: "/hkiff/invited-entry",
      },
      {
        name: "Email Configuration",
        path: "/hkiff/entry-email-config",
      },
    ],
  },
  {
    name: "Accreditation",
    path: "/hkiff/media-accreditation",
    key: "accreditation",
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER, Roles.HKIFF_MA_EDITOR],
    icon: (
      <CheckCircleOutlineOutlinedIcon
        fontSize="small"
        style={{ color: "#BCBCBC" }}
      />
    ),
    children: [
      {
        name: "Media Accreditation",
        path: "/hkiff/media-accreditation",
      },
      {
        name: "Guest Accreditation",
        path: "/hkiff/guest-accreditation",
      },
      {
        name: "Invited Accreditation",
        path: "/hkiff/invited-accreditation",
      },
    ],
  },
  {
    name: "Awards & Juries",
    path: "/hkiff/awards/category",
    icon: <Star fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
    children: [
      { name: "General Setting", path: "/hkiff/awards/general-setting" },
      { name: "Award Listing", path: "/hkiff/awards/list" },
      { name: "Award Category", path: "/hkiff/awards/category" },
      { name: "Juries Listing", path: "/hkiff/awards/juries" },
    ],
  },
  {
    name: "Refund",
    path: "/hkiff/refund/application-list",
    key: "event-manage",
    icon: (
      <MonetizationOnOutlinedIcon
        fontSize="small"
        style={{ color: "#BCBCBC" }}
      />
    ),
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
    children: [
      {
        name: "Application List",
        path: "/hkiff/refund/application-list",
      },
      {
        name: "Event Settings",
        path: "/hkiff/refund/event-settings",
      },
      {
        name: "Venue Settings",
        path: "/hkiff/refund/venue-settings",
      },
      {
        name: "Email Content Settings",
        path: "/hkiff/refund/email-content-settings",
      },
      {
        name: "Terms & Conditions",
        path: "/hkiff/refund/terms-and-conditions",
      },
      {
        name: "Film List",
        path: "/hkiff/refund/film-names",
      },
    ],
  },
  {
    name: "Job",
    path: "/hkiff/job-opportunity/position",
    key: "job-opportunity",
    icon: <WorkIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
    children: [
      {
        name: "General Settings",
        path: "/hkiff/job-opportunity/general-settings",
      },
      {
        name: "Position",
        path: "/hkiff/job-opportunity/position",
      },
    ],
  },
  { divider: true },
  {
    name: "HKIFF Society",
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
  },
  {
    name: "Organization",
    path: "/hkiff/organization",
    key: "organization-group",
    icon: <PeopleIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
    children: [
      {
        name: "Group",
        path: "/hkiff/organization/group",
      },
      {
        name: "Position",
        path: "/hkiff/organization/position",
      },
      {
        name: "Employee",
        path: "/hkiff/organization/employee",
      },
    ],
  },
  {
    name: "Support Us",
    path: "/hkiff/support-us",
    icon: <ThumbUpAltIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
  },
  {
    name: "Contact Us",
    path: "/hkiff/contact-us",
    icon: <PhoneIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
  },
  {
    name: "History & Culture",
    path: "/hkiff/history-culture",
    icon: <HistoryIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
  },
  {
    name: "Company Profile",
    path: "/hkiff/company-profile",
    icon: <FolderIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
  },
  { divider: true },
  {
    name: "eShop",
    path: "/hkiff/eshop/product-category",
    key: "eshop",
    icon: <ShoppingCartIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
    children: [
      {
        name: "Product List",
        path: "/hkiff/eshop/product",
      },
      {
        name: "Product Category",
        path: "/hkiff/eshop/product-category",
      },
      {
        name: "Product Tag",
        path: "/hkiff/eshop/product-tag",
      },
      {
        name: "Transaction",
        path: "/hkiff/eshop/transaction",
      },
      {
        name: "Shipping Setting",
        path: "/hkiff/eshop/shipping-setting",
      },
      {
        name: "Email Content Setting",
        path: "/hkiff/eshop/email-content-setting",
      },
      {
        name: "Setting",
        path: "/hkiff/eshop/setting",
      },
    ],
  },
  { divider: true },
  {
    name: "Using Our Logos",
    path: "/hkiff/logos/logo-group",
    key: "logos",
    icon: <SelectAllIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
    children: [
      {
        name: "General Settings",
        path: "/hkiff/logos/general",
      },
      {
        name: "Logo Group",
        path: "/hkiff/logos/logo-group",
      },
      {
        name: "Logo Listing",
        path: "/hkiff/logos/listing",
      },
    ],
  },
  {
    name: "Report",
    path: "/hkiff/report",
    icon: <AssignmentIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
  },
];

export default menu;
